<div class="fixed-header">
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <!-- <div class="header-actions">
      <a class="mat-link-button" [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
      </a>
  </div> -->
  <!-- Add your header content here -->
</div>
